import api from "./api";
import { iniciarRequisicao, logout } from "../helpers";
import { STATUS_HTTP } from "./statusHTTP";

export const  buscarObservacaoPedido = async (parametros) => {
  const { data, status } = await api.post('/carrinho/buscar-observacao', parametros, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return data.dados;
}

export const salvarObservacaoPedido = async (parametros) => {
  const { data, status } = await api.post('/carrinho/salvar-observacao', parametros, {headers: iniciarRequisicao()}).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();
  localStorage.token = data.token;
  return true;
}

class CarrinhoAPI {
  async verificarPedidoGrupo(headers, params) {
    const response = await api({
      method: "post",
      url: "/car_verificapedido_grupo",
      headers,
      data: params
    });
    return response;
  }

  async getPedido(headers, params) {
    const response = await api.get("/car_getpedido_grupo", { params, headers });
    return response;
  }

  // async addCarrinhoGrupo(headers, params) {
  //   const response = await api({
  //     method: "post",
  //     url: "/car_add_grupo",
  //     headers,
  //     data: params
  //   });
  //   return response;
  // }

  async addMultCarrinhoGrupo(headers, params) {
    const response = await api({
      method: "post",
      url: "/car_mult_add_grupo",
      headers,
      data: params
    });
    return response;
  }

  async excluirProdutos(params) {
    const headers = iniciarRequisicao();

    const config = {
      method: 'delete',
      url: '/carrinhos/produtos',
      headers,
      data: params
    };

    return await api(config);
  }

  // async deleteMultCarrinho(headers, params) {
  //   const response = await api({
  //     method: "delete",
  //     url: "/car_mult_delete",
  //     headers,
  //     data: params
  //   });
  //   return response;
  // }

  async abrirCotacao(headers, params) {
    const response = await api({
      method: "post",
      url: "/car_abrir_cotacao",
      headers,
      data: params
    });
    return response;
  }

  async finalizarPedido(headers, params) {
    const response = await api({
      method: "post",
      url: "/car_finalizar_pedido",
      headers,
      data: params
    });
    return response;
  }

  async atualizarPedidoGrupo(headers, params) {
    const response = await api({
      method: "post",
      url: "/car_atualizar_pedido_grupo",
      headers,
      data: params
    });
    return response;
  }

  async getFornecedorFabricante(headers, params) {
    const response = await api.get("/get_fornecedor_fabricante", {
      params,
      headers
    });
    return response;
  }

  async getRelatoriosCarrinho(headers) {
    const response = await api.get("/get_relatorios_carrinho", { headers });
    return response;
  }

  async setFornecedorCotacaoCissPoder(headers, params) {
    const response = await api({
      method: "post",
      url: "/set_fornecedor_cotacao_ciss_poder",
      headers,
      data: params
    });
    return response;
  }

  async salvarColunasCarrinhoUsuario(headers, params) {
    const response = await api({
      method: "post",
      url: "/salvar_colunas_carrinho_usuario",
      headers,
      data: params
    });
    return response;
  }

  async atualizarMultiplosProdutos (headers, params) {
    const response = await api({
      method: "post",
      url: "/car_atualizar_multiplos_produtos",
      headers,
      data: params
    });
    return response;
  }

  async getPedidosCompraCarrinho(headers, params) {
    return await api.get("/compras_car_get_pedido", {headers, params});
  }

  async getProdutosDoPedidoSelecionado(headers, params) {
    return await api.get("/compras_car_get_produtos_do_pedido", {headers, params});
  }

  async getProdutoDoPedido(headers, params) {
    return await api.get("/compra_multifiliais_get_produto_pedido", {headers, params});
  }

  async consolidarCarrinhosFornecedores (params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: "post",
      url: "/carrinhos/consolidar",
      headers,
      data: params
    });
    return response;
  }
}

export default new CarrinhoAPI();
